var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircleDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99879 16.5C12.4164 16.5 15.9976 12.9183 15.9976 8.5C15.9976 4.08172 12.4164 0.5 7.99879 0.5C3.58118 0.5 0 4.08172 0 8.5C0 12.9183 3.58118 16.5 7.99879 16.5Z",
    fill: "#484848",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99844 9.9002C8.32644 9.9002 8.59844 9.6282 8.59844 9.3002V5.3002C8.59844 4.9722 8.32644 4.7002 7.99844 4.7002C7.67044 4.7002 7.39844 4.9722 7.39844 5.3002V9.3002C7.39844 9.6282 7.67044 9.9002 7.99844 9.9002Z",
    fill: "#484848",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73522 11.3963C8.69522 11.3003 8.63922 11.2123 8.56722 11.1323C8.48722 11.0603 8.39922 11.0043 8.30322 10.9643C8.11122 10.8843 7.88722 10.8843 7.69522 10.9643C7.59922 11.0043 7.51122 11.0603 7.43122 11.1323C7.35922 11.2123 7.30322 11.3003 7.26322 11.3963C7.22322 11.4923 7.19922 11.5963 7.19922 11.7003C7.19922 11.8043 7.22322 11.9083 7.26322 12.0043C7.30322 12.1083 7.35922 12.1883 7.43122 12.2683C7.51122 12.3403 7.59922 12.3963 7.69522 12.4363C7.79122 12.4763 7.89522 12.5003 7.99922 12.5003C8.10322 12.5003 8.20722 12.4763 8.30322 12.4363C8.39922 12.3963 8.48722 12.3403 8.56722 12.2683C8.63922 12.1883 8.69522 12.1083 8.73522 12.0043C8.77522 11.9083 8.79922 11.8043 8.79922 11.7003C8.79922 11.5963 8.77522 11.4923 8.73522 11.3963Z",
    fill: "#484848",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleDark);
export default __webpack_public_path__ + "static/media/info-circle-dark.f53c75594c8627446a6d12ccbc4be6e9.svg";
export { ForwardRef as ReactComponent };